export default {
  cn: [
    {
      version: '2.0.1',
      time: '2019.09.01',
      changes: [
        '使用 <b>render</b> 函数的方式完全重构插件',
        '重构样式设计，使得交互界面更加简洁、清晰',
        '新增 <b>disabled</b> 参数，设置菜单是否禁用',
        '新增 <b>width</b> 参数，自定义菜单宽度',
        '新增 <b>full-width</b> 参数，设置菜单触发对象为 <code>block</code> 布局，默认为 <code>inline-block</code>',
        '修改 <b>position</b> 参数名为 <b>align</b>，功能不变',
        '修改 <b>active-tab</b> 参数名为 <b>active-group</b>，功能不变',
        '修改 <b>regular</b> 参数名为 <b>type</b>，使用显示指定菜单类型，默认值为 <code>advanced</code>',
        '修复部分功能问题',
        '修复部分样式问题',
        '修改 css 预编译程序从 <b>SCSS</b> 至 <b>Stylus</b>',
        '使用 <b>Javascript Standard</b> 语法标准对项目进行格式化',
        '增加 <b>西班牙语</b>, 语言关键字: <code>es</code>',
        '增加 <b>波斯语</b>, 语言关键字: <code>fa</code>',
        '升级 <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a> 升级至 v2.1.1 版本'
      ]
    }, {
      version: '1.0.1 - 1.0.5',
      time: '2018.08.05',
      changes: [
        '增加默认菜单呼出按钮',
        '下拉菜单容器使用插件 <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a>',
        '修复菜单打开状态时再次点击菜单调用者，菜单会再次打开的问题（应关闭）',
        '修复部分样式问题'
      ]
    }, {
      version: '1.0',
      time: '2018.07.08',
      changes: [
        '开发并发布基于 <strong>Vue2</strong> 的 <code>v-selectmenu</code> 插件'
      ]
    }
  ],

  en: [
    {
      version: '2.0.1',
      time: '2019.09.01',
      changes: [
        'Use <b>render functions</b> to completely refactored plugin',
        'Refactoring style design makes the interface more concise and clear',
        "Added <b>disabled</b> prop, you can disable the menu and Disabled menus can't be opened",
        'Added <b>width</b> prop, config to custom menus width',
        'Added <b>full-width</b> prop, set menu trigger display type to <code>block</code>, <code>inline-block</code> by default',
        'Modify <b>position</b> prop name to <b>align</b>, function unchanged',
        'Modify <b>active-tab</b> prop name to <b>active-group</b>, function unchanged',
        'Modify <b>regular</b> prop name to <b>type</b>, explicitly declare the menu type, <code>advanced</code> by default',
        'Fixed some functional bugs',
        'Fixed some stylesheet issues',
        'Change css pre-processor program from <b>SCSS</b> to <b>Stylus</b>',
        'Use <b>Javascript Standard</b> Style to format code',
        'Added <b>Spanish(Español)</b> language, the language key: <code>es</code>',
        'Added <b>Persian</b> language, the language key: <code>fa</code>',
        'Upgrade <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a> plugin to v2.1.1'
      ]
    }, {
      version: '1.0.1 - 1.0.5',
      time: '2018.08.05',
      changes: [
        'Added default menu trigger as a button',
        'The drop down menu container change to plugin <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a>',
        'Fixed menu reopen when menu trigger 2nd time click',
        'Fixed some stylesheet issues'
      ]
    }, {
      version: '1.0',
      time: '2018.07.08',
      changes: [
        'Develop and publish <code>v-selectmenu</code> plugin for <strong>Vue2</strong>'
      ]
    }
  ]
}
